import { getToken } from "./authHeaderService";
import { apiInstance } from "./axiosService";
import { convertObjToQueryParams } from "./commonHelper";

export const getAllAchievement = (payload) => {
  return apiInstance.post("program/getProgram", payload, { headers: getToken() });
};

export const getAllProgramCategory = (payload) => {
  return apiInstance.post("program/getProgramCategory", payload, { headers: getToken() });
};

export const addProgram = (payload) => {
  return apiInstance.post("program/addProgram", payload, { headers: getToken() });
};

export const deleteProgramById = (payload) => {
  return apiInstance.post("program/deleteProgramById", payload, { headers: getToken() });
};

export const addProgramCategory = (payload) => {
  return apiInstance.post("program/addProgramCategory", payload, { headers: getToken() });
};

export const deleteProgramCategoryById = (payload) => {
  return apiInstance.post("program/deleteProgramCategoryById", payload, { headers: getToken() });
};

export const getStatus = (payload) => {
  return apiInstance.get("status/getStatus" + convertObjToQueryParams(payload), { headers: getToken() });
};

export const addStatus = (payload) => {
  return apiInstance.post("status/addStatus", payload, { headers: getToken() });
};

export const deleteStatusById = (payload) => {
  return apiInstance.post("status/deleteStatusById", payload, { headers: getToken() });
};

export const getPermission = (payload) => {
  return apiInstance.get("permission/getPermission" + convertObjToQueryParams(payload), { headers: getToken() });
};

export const addPermission = (payload) => {
  return apiInstance.post("permission/addPermission", payload, { headers: getToken() });
};

export const deletePermissionById = (payload) => {
  return apiInstance.post("permission/deletePermissionById", payload, { headers: getToken() });
};

export const getRoles = (payload) => {
  return apiInstance.get("role/getRoles" + convertObjToQueryParams(payload), { headers: getToken() });
};

export const addRole = (payload) => {
  return apiInstance.post("role/addRole", payload, { headers: getToken() });
};

export const deleteRoleById = (payload) => {
  return apiInstance.post("role/deleteRoleById", payload, { headers: getToken() });
};

export const getRolePermission = (payload) => {
  return apiInstance.get("role-permission/getRolePermission" + convertObjToQueryParams(payload), { headers: getToken() });
};

export const addRolePermission = (payload) => {
  return apiInstance.post("role-permission/addRolePermission", payload, { headers: getToken() });
};

export const deleteRolePermissionById = (payload) => {
  return apiInstance.post("role-permission/deleteRolePermissionById", payload, { headers: getToken() });
};

export const getEmailVendors = (payload) => {
  return apiInstance.get("email-vendor/getEmailVendors" + convertObjToQueryParams(payload), { headers: getToken() });
};

export const addEmailVendor = (payload) => {
  return apiInstance.post("email-vendor/addEmailVendor", payload, { headers: getToken() });
};

export const deleteEmailVendorById = (payload) => {
  return apiInstance.post("email-vendor/deleteEmailVendorById", payload, { headers: getToken() });
};

export const getAllStandard = (payload) => {
  return apiInstance.get("standard/getAllStandard" + convertObjToQueryParams(payload), { headers: getToken() });
};

export const deleteStandardById = (payload) => {
  return apiInstance.post("standard/deleteStandardById", payload, { headers: getToken() });
};

export const createStandard = (payload) => {
  return apiInstance.post("standard/createStandard", payload, { headers: getToken() });
};

export const getAllCountry = (payload) => {
  return apiInstance.get("country/getAllCountry" + convertObjToQueryParams(payload), { headers: getToken() });
};

export const deleteCountryById = (payload) => {
  return apiInstance.post("country/deleteCountryById", payload, { headers: getToken() });
};

export const createCountry = (payload) => {
  return apiInstance.post("country/createCountry", payload, { headers: getToken() });
};

export const getStates = (payload) => {
  return apiInstance.get("state/getStates" + convertObjToQueryParams(payload), { headers: getToken() });
};

export const deleteStateById = (payload) => {
  return apiInstance.post("state/deleteStateById", payload, { headers: getToken() });
};

export const addState = (payload) => {
  return apiInstance.post("state/addState", payload, { headers: getToken() });
};

export const getAllCity = (payload) => {
  return apiInstance.post("city/getAllCity", payload, { headers: getToken() });
};

export const deleteCityById = (payload) => {
  return apiInstance.post("city/deleteCityById", payload, { headers: getToken() });
};

export const addCity = (payload) => {
  return apiInstance.post("city/addCity", payload, { headers: getToken() });
};

export const getAllCollegePagination = (payload) => {
  return apiInstance.get("college/getAllCollegePagination" + convertObjToQueryParams(payload), { headers: getToken() });
};

export const createCollege = (payload) => {
  return apiInstance.post("college/createCollege", payload, { headers: getToken() });
};

export const deleteCollegeById = (payload) => {
  return apiInstance.post("college/deleteCollegeById", payload, { headers: getToken() });
};

export const getAllCourse = (payload) => {
  return apiInstance.get("course/getAllCourse" + convertObjToQueryParams(payload), { headers: getToken() });
};

export const createCourse = (payload) => {
  return apiInstance.post("course/createCourse", payload, { headers: getToken() });
};

export const deleteCourseById = (payload) => {
  return apiInstance.post("course/deleteCourseById", payload, { headers: getToken() });
};

export const getAllParentCourse = (payload) => {
  return apiInstance.get("course/getAllParentCourse", payload, { headers: getToken() });
};

export const addSchoolByStudent = (payload) => {
  return apiInstance.post("school/addSchoolByStudent", payload, { headers: getToken() });
};

export const deleteSchoolById = (payload) => {
  return apiInstance.post("school/deleteSchoolById", payload, { headers: getToken() });
};

export const getAllSchoolsPagination = (payload) => {
  return apiInstance.post("school/getAllSchoolsPagination", payload, { headers: getToken() });
};

export const createBoard = (payload) => {
  return apiInstance.post("board/createBoard", payload, { headers: getToken() });
};

export const deleteBoardById = (payload) => {
  return apiInstance.post("board/deleteBoardById", payload, { headers: getToken() });
};

export const getAllBoard = (payload) => {
  return apiInstance.post("board/getAllBoard", payload, { headers: getToken() });
};

export const createBook = (payload) => {
  return apiInstance.post("book/createBook", payload, { headers: getToken() });
};

export const deleteBookById = (payload) => {
  return apiInstance.post("book/deleteBookById", payload, { headers: getToken() });
};

export const getAllBookPagination = (payload) => {
  return apiInstance.get("book/getAllBookPagination" + convertObjToQueryParams(payload), { headers: getToken() });
};

export const createActivity = (payload) => {
  return apiInstance.post("activity/createActivity", payload, { headers: getToken() });
};

export const deleteActivityById = (payload) => {
  return apiInstance.post("activity/deleteActivityById", payload, { headers: getToken() });
};

export const getAllActivityPagination = (payload) => {
  return apiInstance.get("activity/getAllActivityPagination" + convertObjToQueryParams(payload), { headers: getToken() });
};

export const getCompanies = (payload) => {
  return apiInstance.post("company/getCompanies", payload, { headers: getToken() });
};

export const createCompany = (payload) => {
  return apiInstance.post("company/createCompany", payload, { headers: getToken() });
};

export const deleteCompanyId = (payload) => {
  return apiInstance.post("company/deleteCompanyId", payload, { headers: getToken() });
};

export const getAllUsers = (payload) => {
  return apiInstance.get("user/getAllUsers" + convertObjToQueryParams(payload), { headers: getToken() });
};

export const deleteUserById = (payload) => {
  return apiInstance.post("user/deleteUserById", payload, { headers: getToken() });
};

export const userRegister = (payload) => {
  return apiInstance.post("user/userRegister", payload, { headers: getToken() });
};

export const getAllTodo = (payload) => {
  return apiInstance.get("todo/getAllTodo" + convertObjToQueryParams(payload), { headers: getToken() });
};

export const createTodo = (payload) => {
  return apiInstance.post("todo/createTodo", payload, { headers: getToken() });
};

export const deleteTodoById = (payload) => {
  return apiInstance.post("todo/deleteTodoById", payload, { headers: getToken() });
};

export const getAllCareer = async (payload) => {
  let res =  await apiInstance.get("career/getAllCareer" + convertObjToQueryParams(payload), { headers: getToken() });
  let data = { data: { records: res?.data?.records, totalRecords: res?.data?.totalCount }, ok: res?.ok }
  return data;
};

export const createCareer = (payload) => {
  return apiInstance.post("career/createCareer", payload, { headers: getToken() });
};

export const deleteCareerById = (payload) => {
  return apiInstance.post("career/deleteCareerById", payload, { headers: getToken() });
};

export const getAllIntake = (payload) => {
  return apiInstance.post("intake/getAllIntake", payload, { headers: getToken() });
};

export const createIntake = (payload) => {
  return apiInstance.post("intake/createIntake", payload, { headers: getToken() });
};

export const deleteIntakeById = (payload) => {
  return apiInstance.post("intake/deleteIntakeById", payload, { headers: getToken() });
};

export const getCalendars = (payload) => {
  return apiInstance.get("calendar-system/getCalendars" + convertObjToQueryParams(payload), { headers: getToken() });
};

export const addCalendar = (payload) => {
  return apiInstance.post("calendar-system/addCalendar", payload, { headers: getToken() });
};

export const deleteCalendarById = (payload) => {
  return apiInstance.post("calendar-system/deleteCalendarById", payload, { headers: getToken() });
};

export const getAllExamPagination = (payload) => {
  return apiInstance.get("exam/getAllExamPagination" + convertObjToQueryParams(payload), { headers: getToken() });
};

export const createExam = (payload) => {
  return apiInstance.post("exam/createExam", payload, { headers: getToken() });
};

export const deleteExamById = (payload) => {
  return apiInstance.post("exam/deleteExamById", payload, { headers: getToken() });
};

export const getAllStudentForCms = (payload) => {
  return apiInstance.post("student/getAllStudentForCms", payload, { headers: getToken() });
};

export const studentRegister = (payload) => {
  return apiInstance.post("student/studentRegisterCms", payload, { headers: getToken() });
};

export const getAllLevelWithCount = (payload) => {
  return apiInstance.post("level/getAllLevelWithCount", payload, { headers: getToken() });
};

export const createLevel = (payload) => {
  return apiInstance.post("level/createLevel", payload, { headers: getToken() });
};

export const deleteLevelById = (payload) => {
  return apiInstance.post("level/deleteLevelById", payload, { headers: getToken() });
};

export const getScholarshipMapping = (payload) => {
  return apiInstance.post("scholarship/getScholarshipMapping", payload, { headers: getToken() });
};

export const getScholarships = (payload) => {
  return apiInstance.post("scholarship/getAllScholarships", payload, { headers: getToken() });
};

export const deleteScholarshipById = (payload) => {
  return apiInstance.post("scholarship/deleteScholarshipById", payload, { headers: getToken() });
};

export const createScholarship = (payload) => {
  return apiInstance.post("scholarship/createScholarship", payload, { headers: getToken() });
};

export const deleteScholarshipMappingById = (payload) => {
  return apiInstance.post("scholarship/deleteScholarshipMappingById", payload, { headers: getToken() });
};

export const createScholarshipMapping = (payload) => {
  return apiInstance.post("scholarship/createScholarshipMapping", payload, { headers: getToken() });
};

export const getAllCurrency = (payload) => {
  return apiInstance.post("currency/getAllCurrency", payload, { headers: getToken() });
};

export const deleteCurrencyById = (payload) => {
  return apiInstance.post("currency/deleteCurrencyById", payload, { headers: getToken() });
};

export const createCurrency = (payload) => {
  return apiInstance.post("currency/createCurrency", payload, { headers: getToken() });
};

export const getExamMapping = (payload) => {
  return apiInstance.post("exam/getExamMapping", payload, { headers: getToken() });
};

export const deleteExamMappingById = (payload) => {
  return apiInstance.post("exam/deleteExamMappingById", payload, { headers: getToken() });
};

export const createExamMapping = (payload) => {
  return apiInstance.post("exam/createExamMapping", payload, { headers: getToken() });
};